module.exports = global["$"] = require("-!/home/chinamarket/chinamarket_rails/releases/20200204091313/node_modules/expose-loader/index.js?jQuery!./jquery.js");